/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import * as Yup from 'yup'

import axios from 'axios'
import Swal from 'sweetalert2'
import {useQueryClient} from 'react-query'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {EvaluationReport, EvaluationReportInitValues as initialValues} from '../../core/_models'
import {useNavigate} from 'react-router-dom'

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  data: any
}

const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalCanceledReport: React.FC<Props> = ({show, handleClose, id, data}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()

  const formik = useFormik<EvaluationReport>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        values.id = data.id
        await axios.get(`${API_URL}/sgt/v1/evaluation_reports/cancel_report?`, {
          params: {
            evaluation_report_id: values.id,
            evaluation_report_number: values.evaluation_report_number,
            cancellation_reason: values.cancellation_reason,
          },
        })

        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('property-participations-page=1&items_per_page=10')
        handleClose()
        formik.resetForm()
        navigate('/evaluationreports')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
        formik.resetForm()
        handleClose()
      }
    },
  })

  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>
            {intl.formatMessage({id: 'EVALUATION_REPORT.CANCELLATION_REASON_TITLE'})}
          </span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* INICIO NOME PROPRIEDADE */}
                  <input
                    type='text'
                    className='d-none form-control-lg form-control-solid mb-3 mb-lg-0'
                    // placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                  />
                  {formik.touched.property_id && formik.errors.property_id && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.property_id}</div>
                    </div>
                  )}

                  {/* INICIO NOME PORCENTAGEM */}
                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                      {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                    </label>
                    {/* INICIO LINHA 01*/}
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      id='observations'
                      cols={15}
                      rows={5}
                      {...formik.getFieldProps('cancellation_reason')}
                    ></textarea>
                    {/* FIM NOME PORCENTAGEM */}

                    {/* Submit */}
                    <div className='d-flex justify-content-end py-6'>
                      <button type='submit' className='btn btn-primary' disabled={loading}>
                        {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                  {/* ----------------------------------------------------------------------------------- */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalCanceledReport}
